import Share from 'components/partials/Share';
import AuctionWatch from 'components/Auctions/Details/AuctionWatch';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

function AuctionTitle({
    auction,
    authed,
    regType,
    auctionwatch_loading,
    getData,
    toggleAuctionWatch,
}) {

    const {auction_id} = auction;
    
    return (
        <div className="auction-title">
            <Row>
                <Col className="d-flex align-items-center" sm={6} xs={12}>
                    <span className="auction-details-title">
                        Auction ID:
                        {' '}
                        {auction_id}
                    </span>
                </Col>
                <Col className="d-flex align-items-center justify-content-sm-end justify-content-between" sm={6} xs={12}>
                    <AuctionWatch 
                        auction={auction}
                        authed={authed}
                        regType={regType}
                        auctionwatch_loading={auctionwatch_loading}
                        auction_id={auction_id}
                        getData={getData}
                        toggleAuctionWatch={toggleAuctionWatch}
                    />
                    <div className="auction-details-share">
                        <Share 
                            component="auction-details" 
                            extendedDebouce 
                            page={auction_id}
                            text={`Storagetreasures.com+%7C++Auction+${auction_id}`}
                        />
                    </div>
                </Col>
            </Row>
        </div>
    );
}

export default AuctionTitle;